/** @jsx jsx */
import { css, jsx } from '@emotion/core'

import closeIcon from '../../assets/images/close.png'
import dragIcon from '../../assets/images/drag-and-drop.png'
import copyIcon from '../../assets/images/copy.png'

import { TYPES } from '../../constants'

const { TEXT_ANSWER } = TYPES

const manageCss = (showLastBorder, disable) => css`
  width: 50px;
  border-left: 1px solid #d8dee5;

  .option {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 49px;
    height: 49px;
    user-select: none;

    @media (max-width: 640px) {
      border-bottom: 1px solid #d8dee5;
    }

    ${showLastBorder
      ? css`
          border-bottom: 1px solid #d8dee5;
        `
      : css`
          :not(:last-child) {
            border-bottom: 1px solid #d8dee5;
          }
        `}

    > img {
      transition: all 0.2s ease-in-out;
    }

    ${!disable &&
    css`
      :hover {
        background-color: rgba(0, 0, 0, 0.01);

        > img {
          transform: scale(1.1);
        }
      }
    `}
  }

  .close,
  .copy {
    cursor: pointer;

    > img {
      width: 16px;
    }
  }

  .close {
    ${disable &&
    css`
      cursor: no-drop;
    `}

    > img {
      width: 16px;
      ${disable &&
      css`
        opacity: 0.5;
        cursor: no-drop;
      `}
    }
  }

  .drag-and-drop {
    cursor: grab;
    ${disable &&
    css`
      cursor: no-drop;
    `}

    > img {
      width: 16px;
      ${disable &&
      css`
        opacity: 0.5;
        cursor: no-drop;
      `}
    }
  }
`

const ManagePanel = ({
  type,
  drop,
  copy,
  disable,
  anyAnswers,
  dragHandleProps,
}) => {
  const showLastBorder = type && type === TEXT_ANSWER ? false : anyAnswers
  const dragProps = !disable ? dragHandleProps : {}
  return (
    <div css={manageCss(showLastBorder, disable)}>
      <div className="option close" onClick={!disable ? drop : () => {}}>
        <img src={closeIcon} alt="close" draggable="false" />
      </div>
      <div className="option drag-and-drop" {...dragProps}>
        <img src={dragIcon} alt="drag'n'drop" draggable="false" />
      </div>
      {type && type !== TEXT_ANSWER && (
        <div className="option copy" onClick={copy}>
          <img src={copyIcon} alt="copy" draggable="false" />
        </div>
      )}
    </div>
  )
}

export default ManagePanel
